
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer, Legend } from 'recharts';
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { Users } from 'lucide-react';

interface ClientStatusData {
    name: string;
    value: number;
}

interface ClientStatusReportProps {
    data: ClientStatusData[];
}

const COLORS = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8'];

const ClientStatusReport = ({ data }: ClientStatusReportProps) => {
    // Map status keys to Arabic labels - Updated translations
    const statusLabels: Record<string, string> = {
        'confirmed': 'مؤكد',
        'waiting': 'في الانتظار',
        'in_progress': 'قيد التنفيذ',
        'pricing_requested': 'طلب تسعير',
        'pricing_sent': 'تم إرسال السعر',
        'booking_confirmed': 'تأكيد الحجز',
        'traveling': 'في رحلة',
        'customer_service': 'خدمة العملاء',
        'cancelled': 'ملغي',
        'active': 'نشط',
        'inactive': 'غير نشط',
        'completed': 'مكتمل',
        'unknown': 'غير معروف'
    };

    const chartData = data.map(item => ({...item, name: statusLabels[item.name] || item.name}));

    return (
        <Card className="bg-white/60 backdrop-blur-sm border-slate-200/60">
            <CardHeader>
                <CardTitle className="text-xl font-bold text-slate-800 flex items-center gap-2">
                    <Users className="w-5 h-5" />
                    تقرير حالة العملاء
                </CardTitle>
            </CardHeader>
            <CardContent>
                {data.length > 0 ? (
                    <ResponsiveContainer width="100%" height={300}>
                        <PieChart>
                            <Pie
                                data={chartData}
                                cx="50%"
                                cy="50%"
                                labelLine={false}
                                outerRadius={80}
                                fill="#8884d8"
                                dataKey="value"
                                nameKey="name"
                                label={({ name, percent }) => `${name} ${(percent * 100).toFixed(0)}%`}
                            >
                                {chartData.map((entry, index) => (
                                    <Cell key={`cell-${index}`} fill={COLORS[index % COLORS.length]} />
                                ))}
                            </Pie>
                            <Tooltip formatter={(value, name) => [value, name]} />
                            <Legend />
                        </PieChart>
                    </ResponsiveContainer>
                ) : (
                    <p className="text-center text-slate-500">لا توجد بيانات لعرضها.</p>
                )}
            </CardContent>
        </Card>
    );
};

export default ClientStatusReport;
